document.addEventListener("DOMContentLoaded", () => {



        const cartIcon = document.querySelector('.open-cart-trigger-registry'); // Apne cart icon ka selector
    if (cartIcon) {
        cartIcon.addEventListener('click', (e) => {
            e.preventDefault();
            openCartDrawer();
        });
    }

    // ==========================================
    // CONFIGURATION & INITIALIZATION
    // ==========================================
    const headingWrapper = document.querySelector('.heading-wrapper');
    let customerId = headingWrapper ? headingWrapper.dataset.customer : null;
    const BASE_URL = "https://phpstack-1568591-6103082.cloudwaysapps.com/api";
    
    // ==========================================
    // UTILITY FUNCTIONS
    // ==========================================
    
    /**
     * Show loading spinner in target element
     */
    function showLoader(targetElement) {
        if (!targetElement) return null;
        
        const loader = document.createElement('div');
        loader.className = 'api-loader';
        loader.innerHTML = `<div class="spinner"></div>`;
        
        targetElement.appendChild(loader);
        return loader;
    }
    
    /**
     * Hide and remove loader
     */
    function hideLoader(loader) {
        if (loader && loader.parentNode) {
            loader.remove();
        }
    }
    
    /**
     * Format date as MM/DD/YYYY
     */
    function formatDate(dateString) {
        if (!dateString) return '';
        const dateObj = new Date(dateString);
        const month = String(dateObj.getMonth() + 1).padStart(2, '0');
        const day = String(dateObj.getDate()).padStart(2, '0');
        const year = dateObj.getFullYear();
        return `${month}/${day}/${year}`;
    }
    
    /**
     * Calculate days until event
     */
    function calculateCountdown(eventDate) {
        if (!eventDate) return 'No Date Set';
        
        const event = new Date(eventDate);
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        event.setHours(0, 0, 0, 0);
        
        const diffTime = event - today;
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        
        if (diffDays > 0) return `${diffDays} ${diffDays === 1 ? 'Day' : 'Days'}`;
        if (diffDays === 0) return 'Today';
        return 'Event Passed';
    }
    
    // ==========================================
    // LOCAL STORAGE CART MANAGEMENT
    // ==========================================
    
    /**
     * Get cart from localStorage
     */
    function getLocalCart() {
        try {
            const cart = localStorage.getItem('registry_cart');
            return cart ? JSON.parse(cart) : [];
        } catch (error) {
            console.error('Error reading cart from localStorage:', error);
            return [];
        }
    }
    
    /**
     * Save cart to localStorage
     */
    function saveLocalCart(cart) {
        try {
            localStorage.setItem('registry_cart', JSON.stringify(cart));
        } catch (error) {
            console.error('Error saving cart to localStorage:', error);
        }
    }
    
    /**
     * Calculate cart total
     */
    function calculateCartTotal(cart) {
        return cart.reduce((total, item) => {
            return total + (parseFloat(item.price) * parseInt(item.quantity));
        }, 0);
    }
    
    // ==========================================
    // API-BASED CART DRAWER
    // ==========================================
    
    /**
     * Create Cart Drawer HTML structure
     */
    function createCartDrawer() {
        if (document.getElementById('apiCartDrawer')) return;
        
        const drawerHTML = `
            <div id="apiCartDrawer" class="api-cart-drawer">
                <div class="api-cart-overlay"></div>
                <div class="api-cart-container">
                    <!-- Header -->
                    <div class="api-cart-header">
                        <h2 class="api-cart-title">Your Cart</h2>
                        <button class="api-cart-close" aria-label="Close cart">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <line x1="18" y1="6" x2="6" y2="18"></line>
                                <line x1="6" y1="6" x2="18" y2="18"></line>
                            </svg>
                        </button>
                    </div>
                    
                    <!-- Cart Items -->
                    <div class="api-cart-items" id="apiCartItems">
                        <div class="api-cart-loading">
                            <div class="spinner"></div>
                            <p>Loading cart...</p>
                        </div>
                    </div>
                    
                    <!-- Footer -->
                    <div class="api-cart-footer" id="apiCartFooter" style="display: none;">
                        <div class="api-cart-subtotal">
                            <span>Subtotal</span>
                            <span class="api-cart-total">$0.00</span>
                        </div>
                        <p class="api-cart-note mm">Taxes and shipping calculated at checkout</p>
                        <button class="api-cart-checkout">Proceed to Checkout</button>
                        <button class="api-cart-continue">Continue Shopping</button>
                    </div>
                    <div class="checkout-popup-container" id="pop-container">                        
                        <h2 class="checkout-popup-title">Share Your Message</h2>
                        <form id="checkoutPopupForm" class="checkout-popup-form">
                            <div class="checkout-popup-field">
                                <label for="gifterName">Gifter Name</label>
                                <input 
                                    type="text" 
                                    id="gifterName" 
                                    name="gifter_name" 
                                    placeholder="Enter Gifter name"
                                    required
                                />
                            </div>
                            
                            <div class="checkout-popup-field">
                                <label for="gifterEmail">Gifter Email</label>
                                <input 
                                    type="email" 
                                    id="gifterEmail" 
                                    name="gifter_email" 
                                    placeholder="Enter Gifter email"
                                    required
                                />
                            </div>
                            
                            <div class="checkout-popup-field last-item">
                                <label for="gifterEmail">Gifter social media ( instagram , facebook) </label>
                                <input 
                                    type="text" 
                                    id="gifterinstagramhandle" 
                                    name="gifter_insathandle" 
                                    placeholder="Enter Gifter social media ( instagram , facebook)"
                                />
                            </div>

                            <!-- Checkbox for Personalization -->
                            <div class="checkout-popup-field checkbox-field" id="checkboxMain">
                                <label class="checkbox-label">
                                    <input 
                                        type="checkbox" 
                                        id="personalizationCheckbox" 
                                        name="add_personalization"
                                    />
                                    <span id="personalizationCheckboxLabel">Do you want to add personalization message </span>
                                </label>
                            </div>
                            
                            <div class="checkout-popup-field" id="personalizationField" style="display: none;">
                                <label for="personalizationMessage" id="personalizationTextareaLabel"></label>
                                <textarea 
                                    id="personalizationMessage" 
                                    name="personalization_message" 
                                    placeholder="Enter your"
                                    rows="4"
                                    maxlength=""
                                ></textarea>
                                <small style="color: #666; font-size: 12px;" id="maxCh">Maximum characters</small>
                            </div>
                            
                            <button type="submit" class="checkout-popup-submit checkout-popup-proceed">
                                <span class="btn-text">Checkout</span>
                                <span class="btn-loader" style="display: none;"></span>
                            </button>
                            
                            <button type="button" class="checkout-popup-submit checkout-popup-add-more">
                                Add More Gifts
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        `;
        
        document.body.insertAdjacentHTML('beforeend', drawerHTML);
        initializeCartDrawer();
    }
    
    /**
     * Initialize Cart Drawer event listeners
     */
    function initializeCartDrawer() {
        const drawer = document.getElementById('apiCartDrawer');
        if (!drawer) return;
        
        const overlay = drawer.querySelector('.api-cart-overlay');
        const closeBtn = drawer.querySelector('.api-cart-close');
        const continueBtn = drawer.querySelector('.api-cart-continue');
        const checkoutBtn = drawer.querySelector('.checkout-popup-submit');
        const registryDetails = document.querySelector('.view-registry-header');
        const registryId = registryDetails?.getAttribute('data-registry-id');
        const customerId = registryDetails?.getAttribute('data-customer-id');
        const openCheckoutBtn = drawer.querySelector('.api-cart-checkout');
        const popupContainer = drawer.querySelector('#pop-container');
        const addMoreBtn = drawer.querySelector('.checkout-popup-add-more');
        const checkoutForm = drawer.querySelector('#checkoutPopupForm');
        const checkbox = document.getElementById('personalizationCheckbox');
        const textareaField = document.getElementById('personalizationField');
        const shopMetaDiv = registryDetails?.querySelector('.shopmeta');

let shopMeta = null;
if (shopMetaDiv) {
    try {
        shopMeta = JSON.parse(shopMetaDiv.textContent);
        console.log('Shop Meta:', shopMeta);

        if (shopMeta.show_in_cart && checkbox && textareaField) {
            checkbox.parentElement.parentElement.style.display = 'block'; 
            textareaField.style.display = 'none';
        } else if (checkbox && textareaField) {
            checkbox.parentElement.parentElement.style.display = 'none';
        }

        if (textareaField) {
            const textarea = textareaField.querySelector('textarea');
            if (textarea && shopMeta.char_limit) {
                textarea.setAttribute('maxlength', shopMeta.char_limit);
                const maxChLabel = textareaField.querySelector('#maxCh');
                if (maxChLabel) {
                    maxChLabel.textContent = `Maximum ${shopMeta.char_limit} characters.`;
                }
            }
        }

        if (shopMeta.price) {
            const priceLabel = document.createElement('small');
            priceLabel.style.color = '#666';
            priceLabel.textContent = `Personalization Cost: $${shopMeta.price.toFixed(2)}`;
            textareaField.appendChild(priceLabel);
        }

    } catch (err) {
        console.error('Failed to parse shopMeta JSON:', err);
    }
}



        if (!checkbox || !textareaField) return;

        checkbox.addEventListener('change', () => {
                if (checkbox.checked) {
                    textareaField.style.display = 'flex';
                } else {
                    textareaField.style.display = 'none';
                }
            });

        if (openCheckoutBtn) {
            openCheckoutBtn.addEventListener('click', () => {
                popupContainer.classList.add('active');
            });
        }

        if (addMoreBtn) {
            addMoreBtn.addEventListener('click', () => {
                popupContainer.classList.remove('active');
                closeCartDrawer();
            });
        }

        
        // Close drawer
        [overlay, closeBtn, continueBtn].forEach(el => {
            if (el) {
                el.addEventListener('click', () => {
                    closeCartDrawer();
                    popupContainer.classList.remove('active');
                });
            }
        });
        
        // Checkout button
        if (checkoutBtn) {
            checkoutBtn.addEventListener('click', async () => {
                try {
                    const cart = getLocalCart();

                    const gifterName = document.getElementById('gifterName').value;
                    const gifterEmail = document.getElementById('gifterEmail').value;
                    const personalizationMessage = document.getElementById('personalizationMessage')?.value || '';

                    
                    if (cart.length === 0) {
                        alert('Your cart is empty');
                        return;
                    }

                    const lineItems = cart.map(item => ({
                        price: parseFloat(item.price).toFixed(2), 
                        variant_id: item.variant_id,
                        quantity: parseInt(item.quantity),
                        customization_input: item.value
                        ? { value: item.value }
                        : null
                    }));

                    const payload = {
                        lineItems: lineItems,
                        gifter_name: gifterName,
                        gifter_email: gifterEmail,
                        personalization_message: personalizationMessage,
                    };

                    if (customerId || registryId) {
                        payload.customer_id = customerId;
                        payload.registry_id = registryId;
                    }

                    checkoutBtn.disabled = true;
                    
                    // Add loader without changing text
                    const originalHTML = checkoutBtn.innerHTML;
                    checkoutBtn.innerHTML = `
                        <span style="display: flex; align-items: center; justify-content: center; gap: 8px;">
                            <span class="spinner" style="width: 16px; height: 16px;"></span>
                            <span>Proceed to Checkout</span>
                        </span>
                    `;

                    const response = await fetch(`${BASE_URL}/create-draft-order`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(payload)
                    });

                    const result = await response.json();
                    console.log('Draft order response:', result);
                    
                    if (result.status && result.draft_order && result.draft_order.invoiceUrl) {
                        // Clear cart on successful checkout
                        saveLocalCart([]);
                        window.location.href = result.draft_order.invoiceUrl;
                        checkoutBtn.disabled = false;
                        checkoutBtn.innerHTML = 'Proceed to Checkout';
                    } else {
                        alert('Checkout failed. Please try again.');
                        checkoutBtn.disabled = false;
                        checkoutBtn.innerHTML = originalHTML;
                    }

                } catch (error) {
                    console.error('Checkout Error:', error);
                    alert('Checkout failed. Please try again.');
                    checkoutBtn.disabled = false;
                    checkoutBtn.innerHTML = 'Proceed to Checkout';
                }finally {
                    checkoutBtn.innerHTML = originalHTML;
                }
            });
        }

    }
    
    /**
     * Open Cart Drawer and load items
     */
    async function openCartDrawer() {
        createCartDrawer();

        const drawer = document.getElementById('apiCartDrawer');
        if (!drawer) return;

        drawer.classList.add('active');
        document.body.style.overflow = 'hidden';

        // Load cart from localStorage
        const cart = getLocalCart();
        const total = calculateCartTotal(cart);
        loadCartItems(cart, total.toFixed(2));
    }
    
    /**
     * Close Cart Drawer
     */
    function closeCartDrawer() {
        const drawer = document.getElementById('apiCartDrawer');
        if (!drawer) return;
        
        drawer.classList.remove('active');
        document.body.style.overflow = '';
    }
    
    /**
     * Load cart items in the drawer
     */
    function loadCartItems(cart = [], total = '0.00') {
        const itemsContainer = document.getElementById('apiCartItems');
        const footer = document.getElementById('apiCartFooter');

        if (!itemsContainer) return;

        // Empty cart
        if (!cart.length) {
            itemsContainer.innerHTML = `
                <div class="api-cart-empty">
                    <p>Your cart is empty</p>
                </div>
            `;
            footer.style.display = 'none';
            return;
        }
        
        // Render cart items
        itemsContainer.innerHTML = cart.map((item, index) => `
            <div class="api-cart-item" 
                data-variant-id="${item.variant_id}" 
                data-price="${item.price}"
                data-text="${item.value}"
                data-quantity="${item.quantity}">
                ${item.metafield ? `<div class="metaData">${item.metafield}</div>` : ''}
                <div class="api-cart-item-image">
                    ${item.image
                        ? `<img src="${item.image}" alt="${item.title}">`
                        : `<div class="api-cart-no-image">No Image</div>`
                    }
                </div>

                <div class="api-cart-item-details">
                    <h3 class="api-cart-item-title">${item.title}</h3>
                    <div class="api-cart-item-price">
                        $${parseFloat(item.price).toFixed(2)}
                    </div>
                    ${item.value ? `<h3 class="api_cart_value">Customize text: ${item.value}</h3>` : ''}

                    <div class="api-cart-qty-controls">
                        <button class="api-cart-qty-btn api-cart-qty-minus" data-variant-id="${index}">-</button>
                        <span class="api-cart-qty-display">${item.quantity}</span>
                        <button class="api-cart-qty-btn api-cart-qty-plus" data-variant-id="${index}">+</button>
                    </div>
                </div>

                <button
                    class="api-cart-item-remove"
                    data-variant-id="${index}"
                    aria-label="Remove"
                >✕</button>
            </div>
        `).join('');

        // Update footer total
        const totalElement = footer.querySelector('.api-cart-total');
        if (totalElement) {
            totalElement.textContent = `$${parseFloat(total).toFixed(2)}`;
        }

        footer.style.display = 'block';
        // Initialize cart item controls
        initializeCartItemControls();
    }
    
    /**
     * Initialize cart item controls (quantity, remove)
     */
    function initializeCartItemControls() {
        const itemsContainer = document.getElementById('apiCartItems');
        if (!itemsContainer) return;
        
        // Quantity increase
        itemsContainer.querySelectorAll('.api-cart-qty-plus').forEach(btn => {
            btn.addEventListener('click', () => {
                const variantId = btn.dataset.variantId;
                updateCartItemQuantity(variantId, 1);
            });
        });
        
        // Quantity decrease
        itemsContainer.querySelectorAll('.api-cart-qty-minus').forEach(btn => {
            btn.addEventListener('click', () => {
                const variantId = btn.dataset.variantId;
                updateCartItemQuantity(variantId, -1);
            });
        });
        
        // Remove item
        itemsContainer.querySelectorAll('.api-cart-item-remove').forEach(btn => {
            btn.addEventListener('click', () => {
                const variantId = btn.dataset.variantId;
                removeFromCart(variantId);
            });
        });
    }
    
    /**
     * Update cart item quantity
     */
    function updateCartItemQuantity(variantId, change) {
        let cart = getLocalCart();
        // const itemIndex = cart.findIndex(item => item.variant_id === variantId);
        
        // if (itemIndex !== -1) {
        //     cart[itemIndex].quantity = parseInt(cart[itemIndex].quantity) + change;
            
        //     // Remove if quantity is 0 or less
        //     if (cart[itemIndex].quantity <= 0) {
        //         cart.splice(itemIndex, 1);
        //     }

            
    if (variantId >= 0 && variantId < cart.length) {
        cart[variantId].quantity = parseInt(cart[variantId].quantity) + change;
        
        if (cart[variantId].quantity <= 0) {
            cart.splice(variantId, 1);
        }
            
            saveLocalCart(cart);
            
            // Refresh display
            const total = calculateCartTotal(cart);
            loadCartItems(cart, total.toFixed(2));
        }
    }
    
    /**
     * Remove item from cart
     */
    function removeFromCart(variantId) {
        let cart = getLocalCart();
        cart = cart.filter(item => item.variant_id !== variantId);
        saveLocalCart(cart);
        
        // Refresh display
        const total = calculateCartTotal(cart);
        loadCartItems(cart, total.toFixed(2));
    }
    
    // ==========================================
    // CREATE REGISTRY PAGE
    // ==========================================
    const isCreateRegistryPage = !window.location.pathname.includes('update-registry');
    const createForm = isCreateRegistryPage ? document.getElementById("create-registry-form") : null;
    
    if (createForm) {
        console.log('Create Registry Page Loaded');
        
        createForm.addEventListener("submit", async (e) => {
            e.preventDefault();
            
            const registryData = {
                customer_id: customerId,
                // event_type: document.getElementById("event_type").value,
                event_date: document.getElementById("event_date").value,
                registry_name: document.getElementById("registry_name").value,
                first_name: document.getElementById("first_name").value,
                last_name: document.getElementById("last_name").value,
                share_invitation_message: document.getElementById("invitation_message").value,
                registrant_address_info: {
                    address1: document.getElementById("start_address").value,
                    zip: document.getElementById("zip_code").value,
                    city: document.getElementById("city").value,
                    state: document.getElementById("state").value,
                    country: document.getElementById("country").value,
                    phone: document.getElementById("phone_number").value
                }
            };
            
            const submitBtn = createForm.querySelector('button[type="submit"]');
            const originalBtnText = submitBtn ? submitBtn.textContent : '';
            let loader = null;
            
            if (submitBtn) {
                submitBtn.disabled = true;
                submitBtn.textContent = ' ';
                loader = showLoader(submitBtn);
                loader.classList.add('button-loader');
            }
      
            try {
                const response = await fetch(`${BASE_URL}/create-registry`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(registryData)
                });
      
                const data = await response.json();
      
                if (data.success) {
                    createForm.reset();
                    const registryCode = data.data.registry_id;
                    window.location.href = `view-registry/view-as-owner?id=${registryCode}`;
                } else {
                    alert("Error: " + data.message);
                }
            } catch (error) {
                console.error("Create Registry Error:", error);
                alert("Request failed. Please try again.");
            } finally {
                if (submitBtn) {
                    hideLoader(loader);
                    submitBtn.disabled = false;
                    submitBtn.textContent = originalBtnText;
                }
            }
        });
    }
  
    // ==========================================
    // MANAGE REGISTRY PAGE
    // ==========================================
    const registryWrapper = document.querySelector('.registry-cards-wrapper');
    const registryCountSpan = document.querySelector('.registry-count');
    const headingWrappermanage = document.querySelector('.heading-wrapper');
    
    if (registryWrapper) {
        customerId = registryWrapper.dataset.customer;
    }
  
    if (registryWrapper && registryCountSpan) {
        console.log('Manage Registry Page Loaded');
        
        const fetchRegistries = async () => {
            const loader = showLoader(registryWrapper);
            
            try {
                const response = await fetch(`${BASE_URL}/list-registries?customer_id=${customerId}`);
                const data = await response.json();
      
                if (data.success) {
                    populateRegistryCards(data.data);
                } else {
                    console.error("Error fetching registries:", data.message);
                }
            } catch (error) {
                console.error("Fetch Registries Error:", error);
            } finally {
                hideLoader(loader);
                if (headingWrappermanage) {
                    headingWrappermanage.style.display = '';
                }
            }
        };
  
        const populateRegistryCards = (registries) => {
            const templateCard = registryWrapper.querySelector('.registry-card');
            const emptyState = registryWrapper.querySelector('.empty-registry-state');
            
            if (!templateCard || !emptyState) return;

            if (!registries || registries.length === 0) {
                registryWrapper.querySelectorAll('.registry-card').forEach(card => card.style.display = 'none');
                emptyState.style.display = 'block';
                registryCountSpan.textContent = '0 Registries';
            } else {
                emptyState.style.display = 'none';
                templateCard.style.display = 'none';
                
                registryWrapper.querySelectorAll('.registry-card:not([data-template])').forEach(card => card.remove());
                templateCard.setAttribute('data-template', 'true');
                
                registries.forEach(registry => {
                    const card = templateCard.cloneNode(true);
                    card.removeAttribute('data-template');
                    card.style.display = '';

                    card.querySelector('.avatar-initials').textContent = 
                        (registry.first_name?.charAt(0) || '') + (registry.last_name?.charAt(0) || '');
                    card.querySelector('.registry-name').textContent = registry.registry_name || '';
                    card.querySelector('.detail-item:nth-child(1) .detail-value').textContent = registry.id || '';
                    card.querySelector('.detail-item:nth-child(2) .detail-value').textContent = formatDate(registry.event_date);
                    // card.querySelector('.detail-item:nth-child(3) .detail-value').textContent = registry.event_type || '';
                    card.querySelector('.invitation-quote p').textContent = registry.share_invitation_message || '';
                    
                    const viewBtn = card.querySelector('.view-registry-btn');
                    if (viewBtn) viewBtn.setAttribute('data-registry-id', registry.registry_id || registry.id || '');

                    const shareBtn = card.querySelector('.share-icon');
                    if (shareBtn) {
                        shareBtn.dataset.registryName = registry.registry_name || '';
                        shareBtn.dataset.registryId = registry.registry_id || '';
                    }

                    const editBtn = card.querySelector('.edit-icon');
                    if (editBtn) editBtn.dataset.registryId = registry.id || '';

                    const deleteBtn = card.querySelector('.delete-icon');
                    if (deleteBtn) deleteBtn.dataset.registryId = registry.id || '';

                    registryWrapper.appendChild(card);
                });
                
                registryCountSpan.textContent = `${registries.length} Registries`;
            }
        };
        
        fetchRegistries();

        registryWrapper.addEventListener('click', (e) => {
            const editBtn = e.target.closest('.edit-icon');
            if (editBtn && editBtn.dataset.registryId) {
                window.location.href = `update-registry?id=${editBtn.dataset.registryId}`;
            }
        });

        registryWrapper.addEventListener('click', async (e) => {
            const deleteBtn = e.target.closest('.delete-icon');
            if (!deleteBtn || !deleteBtn.dataset.registryId) return;
            
            if (!confirm('Are you sure you want to delete this registry? This action cannot be undone.')) {
                return;
            }

            const registryId = deleteBtn.dataset.registryId;

            try {
                const response = await fetch(`${BASE_URL}/delete-registry/${registryId}`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" }
                });

                const data = await response.json();

                if (data.success) {
                    fetchRegistries();
                } else {
                    alert("Error: " + (data.message || "Unknown error"));
                }
            } catch (error) {
                console.error("Delete Registry Error:", error);
                alert("Request failed. Please try again.");
            }
        });

        const modalOverlay = document.getElementById('shareModalOverlay');
        const modalCloseBtn = document.getElementById('modalCloseBtn');
        const modalTitle = document.getElementById('modalTitle');
        const shareUrlInput = document.getElementById('shareUrlInput');
        const copyBtn = document.getElementById('copyBtn');
        
        if (modalOverlay && modalCloseBtn && modalTitle && shareUrlInput && copyBtn) {
            registryWrapper.addEventListener('click', (e) => {
                const shareButton = e.target.closest('.share-icon');
                if (shareButton) {
                    const registryName = shareButton.getAttribute('data-registry-name');
                    const registryId = shareButton.getAttribute('data-registry-id');
                    
                    modalTitle.textContent = `${registryName} | ${registryId}`;
                    
                    const baseUrl = window.location.origin;
                    shareUrlInput.value = `${baseUrl}/pages/view-registry/view-as-gifter?id=${registryId}`;
                    
                    modalOverlay.classList.add('active');
                }
            });
            
            modalCloseBtn.addEventListener('click', () => {
                modalOverlay.classList.remove('active');
            });
            
            modalOverlay.addEventListener('click', (e) => {
                if (e.target === modalOverlay) {
                    modalOverlay.classList.remove('active');
                }
            });
            
            copyBtn.addEventListener('click', () => {
                shareUrlInput.select();
                shareUrlInput.setSelectionRange(0, 99999);
                
                navigator.clipboard.writeText(shareUrlInput.value).then(() => {
                    const originalText = copyBtn.textContent;
                    copyBtn.textContent = 'COPIED!';
                    
                    setTimeout(() => {
                        copyBtn.textContent = originalText;
                    }, 2000);
                }).catch(() => {
                    try {
                        document.execCommand('copy');
                        const originalText = copyBtn.textContent;
                        copyBtn.textContent = 'COPIED!';
                        
                        setTimeout(() => {
                            copyBtn.textContent = originalText;
                        }, 2000);
                    } catch (err) {
                        alert('Failed to copy link');
                    }
                });
            });
        }
    }


    // ==========================================
    // REGISTRY BUTTON COMPONENT
    // ==========================================
    class RegistryButton extends HTMLElement {
        constructor() {
            super();
        }
  
        connectedCallback() {
            const button = this.querySelector('.view-registry-btn');
            if (!button) return;
            
            const registryId = button.dataset.registryId;
            
            button.addEventListener('click', async () => {
                try {
                    const response = await fetch(`${BASE_URL}/get-registry/${registryId}`);
                    if (!response.ok) throw new Error('Failed to fetch registry');
          
                    const data = await response.json();
                    console.log('Registry details:', data);
          
                    window.location.href = `view-registry/view-as-owner?id=${registryId}`;
                } catch (error) {
                    console.error("View Registry Error:", error);
                }
            });
        }
    }
  
    customElements.define('registry-button', RegistryButton);

    // ==========================================
    // VIEW REGISTRY PAGE
    // ==========================================
    const viewRegistryHeader = document.querySelector('.view-registry-header');
    const viewRegistryContainer = document.querySelector('.header-container');
    const viewRegistrycontent = document.querySelector('.content-container');
    const viewRegistryasGifter = document.querySelector('.add-products-btn');
    
    if (viewRegistryHeader) {
        console.log('View Registry Page Loaded');
        
        const currentPath = window.location.pathname;
        const isOwnerView = currentPath.includes('view-as-owner');
        const isGifterView = currentPath.includes('view-as-gifter');
        
        console.log('View Mode:', isOwnerView ? 'OWNER' : isGifterView ? 'GIFTER' : 'UNKNOWN');
        
        const urlParams = new URLSearchParams(window.location.search);
        const registryId = urlParams.get('id');
        if (isGifterView && viewRegistryasGifter) {
                viewRegistryasGifter.style.display = 'none';
            }
            if (isGifterView) {
                document.querySelectorAll('.tab-btn').forEach(tab => {
                    const tabType = tab.getAttribute('data-tab');
                    if (tabType === 'still-need' || tabType === 'fulfilled') {
                        tab.style.display = 'none';
                    }
                });
            }

        
        if (registryId) {
            const populateViewRegistry = async () => {
                const loader = showLoader(viewRegistryHeader);
                
                try {
                    const response = await fetch(`${BASE_URL}/get-registry/${registryId}`);
                    if (!response.ok) throw new Error('Failed to fetch registry');
                    const data = await response.json();
                    console.log('Registry details:', data);
                    viewRegistryHeader.setAttribute('data-registry-id', data.data.id);
                   
                    viewRegistryHeader.setAttribute('data-customer-id', data.data.customer_id);
                    if (data.success && data.data) {
                        const registry = data.data;
                        
                        const avatarInitials = viewRegistryHeader.querySelector('.avatar-initials');
                        if (avatarInitials && registry.first_name && registry.last_name) {
                            avatarInitials.textContent = registry.first_name.charAt(0) + registry.last_name.charAt(0);
                        }
                        
                        const registryTitle = viewRegistryHeader.querySelector('.registry-title');
                        if (registryTitle) registryTitle.textContent = registry.registry_name || '';
                        
                        viewRegistryHeader.querySelectorAll('.detail-row').forEach(row => {
                            const label = row.querySelector('.detail-label');
                            const value = row.querySelector('.detail-value');
                            
                            if (label && value) {
                                const labelText = label.textContent.trim();
                                
                                if (labelText.includes('EVENT TYPE')) {
                                    value.textContent = registry.event_type || '';
                                } else if (labelText.includes('EVENT DATE')) {
                                    value.textContent = registry.event_date || '';
                                } else if (labelText.includes('REGISTRY ID')) {
                                    value.textContent = registry.id || registry.registry_id || '';
                                } else if (labelText.includes('REGISTRANT NAME')) {
                                    value.textContent = `${registry.first_name || ''} ${registry.last_name || ''}`.trim();
                                }
                            }
                        });
                        
                        const invitationText = viewRegistryHeader.querySelector('.invitation-text');
                        if (invitationText) invitationText.textContent = registry.share_invitation_message || '';
                        
                        const countdownText = viewRegistryHeader.querySelector('.countdown-text');
                        if (countdownText && registry.event_date) {
                            countdownText.textContent = calculateCountdown(registry.event_date);
                        }
                        
                        let products = registry.products || registry.items || registry.product || [];
                        if (!Array.isArray(products)) products = [];
                        
                        console.log('Products found:', products.length);
                        
                        const statValues = viewRegistryHeader.querySelectorAll('.stat-value');
                        if (statValues.length >= 1) statValues[0].textContent = products.length;
                        if (statValues.length >= 2) statValues[1].textContent = registry.orders_count || 0;
                        
                        populateProducts(products, isGifterView);
                    }
                } catch (error) {
                    console.error('View Registry Error:', error);
                } finally {
                    hideLoader(loader);
                    if (viewRegistryContainer || viewRegistrycontent) {
                        viewRegistryContainer.style.display = '';
                        viewRegistrycontent.style.display = '';
                    }
                }
            };
            
            /**
             * Populate products based on view mode
             * FIXED: Properly handle gifter view with quantity controls
             */



            const populateProducts = (products, showAddToCart = false) => {
                console.log('Populating products:', products.length, 'Show Add to Cart:', showAddToCart);

                
                const productsList = document.querySelector('.products-list');
                const noProductsMessage = document.querySelector('.no-products-message');
                const productsCount = document.querySelector('.products-count');
                const productsonlyOwner = document.getElementById('order__only__owner');
                
                if (!productsList || !noProductsMessage) {
                    console.error('Products list elements not found');
                    return;
                }
                
                productsList.innerHTML = '';
                
                if (products && Array.isArray(products) && products.length > 0) {
                    noProductsMessage.style.display = 'none';
                    productsList.style.display = 'flex';
                    
                    if (productsCount) {
                        productsCount.textContent = `${products.length} ${products.length === 1 ? 'Product' : 'Products'}`;
                    }

                    products.forEach((product, index) => {
                        const productId = product.id || product.product_id || index + 1;
                        const firstVariantId = product.variant_id;
                        const metafieldData = product.metafields;
                        const productName = product.name || product.title || product.product_name || 'Product';
                        const productImage = product.image || product.image_url || product.product_image || '';
                        const productPrice = parseFloat(product.price || product.product_price || '0.00');
                        const productQuantity = parseInt(product.quantity || product.want_quantity || 1);
                        const productPurchased = parseInt(product.purchased || product.purchased_quantity || 0);
                        const productStock = product.original_quantity;
                        
                        // Calculate remaining quantity for gifter view
                        const remainingQuantity = productQuantity - productPurchased;
                        
                        const isSoldOut = product.is_sold_out || product.in_stock === false || product.status === 'sold-out';
                        const isFulfilled = product.fulfilled || productPurchased >= productQuantity || product.status === 'fulfilled';
                        
                        // Determine product category
                        let productTab = 'all';
                        if (isSoldOut || productStock === 0) {
                            productTab = 'sold-out';
                        } else if (isFulfilled) {
                            productTab = 'fulfilled';
                        } else {
                            productTab = 'still-need'; // Available products
                        }
                        
                        const productCard = document.createElement('div');
                        const metafieldupdate = JSON.stringify(metafieldData);
                        productCard.className = 'product-card';
                        productCard.setAttribute('data-product-id', productId);
                        productCard.setAttribute('data-variant-id', firstVariantId);
                        productCard.setAttribute('data-product-title', productName);
                        productCard.setAttribute('data-product-price', productPrice);
                        productCard.setAttribute('data-product-image', productImage);
                        productCard.setAttribute('data-tab', productTab);
                        productCard.setAttribute('data-remaining-quantity', remainingQuantity);
                        productCard.setAttribute('metafield-data', JSON.parse(metafieldupdate));
                        productCard.setAttribute('data-productstock', productStock)
                        
                        let controlsHTML = '';
                        
                        if (!showAddToCart) {
                            // OWNER VIEW - Show update quantity controls
                            controlsHTML = `
                                <div class="product-controls">
                                    <div class="quantity-controls">
                                        <button class="quantity-btn minus-btn" data-product-id="${productId}">-</button>
                                        <input type="number" class="quantity-input" value="${productQuantity}" min="0" data-product-id="${productId}">
                                        <button class="quantity-btn plus-btn" data-product-id="${productId}">+</button>
                                    </div>
                                    <button class="update-quantity-btn" data-product-id="${productId}">
                                        <span class="btn-text">Update Quantity</span>
                                        <span class="btn-loader" style="display: none;"></span>
                                    </button>
                                </div>
                            `;
                        } else {
                            // GIFTER VIEW - Simple add to cart button (adds full "want" quantity)
                            if (remainingQuantity > 0 && !isSoldOut && !isFulfilled) {
                                controlsHTML = `
                                    <div class="product-controls">
 
                                `;
                                           if (metafieldData) {
    try {
        let meta = metafieldData;
        if (typeof meta === 'string') meta = JSON.parse(meta.replace(/=>/g, ':'));

        let custom = meta.customization_1 ? meta.customization_1 : meta;
        if (typeof custom === 'string') custom = JSON.parse(custom.replace(/=>/g, ':'));

        // ✅ ONLY show if label exists
        if (custom.label) {
            const labelText = custom.label;
            const maxChars = custom.char_limit || 200;
            const maxPriceCus = custom.price


            controlsHTML += `
                <div class="personalization-container" data-product-id="${productId}">
                    <label>
                        <input 
                            type="checkbox" 
                            class="personalization-checkbox" 
                            data-product-id="${productId}"
                        >
                        Do you want to customize it?
                    </label>
                    <span class="product_card-label" style="display:none;">${labelText}</span>
                    <input
                        type="text"
                        class="personalization-input" 
                        data-product-id="${productId}" 
                        placeholder="Enter your message"
                        maxlength="${maxChars}"
                        style="display:none;"
                    ></input>
                    <small style="color: #666; font-size: 12px; display: none" id="product_max">Maximum ${maxChars} characters.</small>
                    <small style="color: rgb(102, 102, 102); display: none" id="productPrice_cost">Personalization Cost: $${maxPriceCus}</small>
                </div>
            `;
        }

    } catch (err) {
        console.warn('Invalid metafield JSON for personalization', metafieldData);
    }
}
controlsHTML += `
        <button class="add-to-cart-btn" data-remaining="${remainingQuantity}">
            <span class="btn-text">Add to Cart</span>
            <span class="btn-loader" style="display:none;"></span>
        </button>
    </div>
`;
                                viewRegistryasGifter.style.display = 'none'
                                productsonlyOwner.style.display = 'none'
                            } else {
                                // Product is fulfilled or sold out - no controls
                                controlsHTML = `
                                    <div class="product-controls">
                                        <button class="add-to-cart-btn" disabled>Not Available</button>
                                    </div>
                                `;
                            }
                        }
                        
                        const soldOutBadge = isSoldOut ? '<span class="sold-out-badge">Sold Out</span>' : '';
                        const fulfilledBadge = isFulfilled && !isSoldOut ? '<span class="fulfilled-badge">Fulfilled</span>' : '';
                        
                        // Calculate total price based on product quantity
                        const totalPrice = (productPrice * productQuantity).toFixed(2);
                        
                        productCard.innerHTML = `
                            <div class="product-image">
                                ${productImage ? `<img src="${productImage}" alt="${productName}">` : '<div class="product-image-placeholder">No Image</div>'}
                                ${soldOutBadge}
                                ${fulfilledBadge}
                            </div>
                            <div class="product-details">
                                <h3 class="product-title">${productName}</h3>
                                <div class="product-info">
                                    <span class="product-price">$${totalPrice}</span>
                                    <span class="product-want">Want ${productQuantity} • Purchased ${productPurchased}</span>
                                </div>
                                ${controlsHTML}
                            </div>
                        `;
                        
                        productsList.appendChild(productCard);
                    });
                    
                    // Initialize controls based on view mode
                    if (showAddToCart) {
                        initializeGifterControls();
                    } else {
                        initializeOwnerControls();
                    }
                    
                    // Apply initial filter
                    const activeTab = document.querySelector('.tab-btn.active');
                    if (activeTab && window.filterProductsByTab) {
                        window.filterProductsByTab(activeTab.getAttribute('data-tab') || 'all');
                    } else {
                        window.filterProductsByTab('all');
                    }
                } else {
                    noProductsMessage.style.display = 'block';
                    productsList.style.display = 'none';
                    if (productsCount) productsCount.textContent = '0 Products';
                }
            };
            
            /**
             * Update product quantity in registry database
             */
            async function updateProductQuantityInRegistry(productId, quantity) {
                try {
                    const response = await fetch(`${BASE_URL}/update-product-quantity`, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({
                            registry_id: registryId,
                            product_id: productId,
                            quantity: quantity
                        })
                    });

                    const data = await response.json();

                    if (!response.ok || data.success === false) {
                        throw new Error(data.message || 'Failed to update product quantity');
                    }

                    return { success: true, productId, quantity };
                } catch (error) {
                    console.error('Update Quantity Error:', error);
                    throw error;
                }
            }

            /**
             * Update product count display
             */
            function updateProductCount() {
                const productsCount = document.querySelector('.products-count');
                const productsList = document.querySelector('.products-list');
                
                if (productsCount && productsList) {
                    const visibleProducts = productsList.querySelectorAll('.product-card:not([style*="display: none"])').length;
                    productsCount.textContent = `${visibleProducts} ${visibleProducts === 1 ? 'Product' : 'Products'}`;
                    
                    // Update stat value in header
                    const statValues = document.querySelectorAll('.stat-value');
                    if (statValues.length >= 1) {
                        statValues[0].textContent = visibleProducts;
                    }
                }
            }

            /**
             * Check if products list is empty and show message
             */
            function checkEmptyProductsList() {
                const productsList = document.querySelector('.products-list');
                const noProductsMessage = document.querySelector('.no-products-message');
                
                if (productsList && productsList.children.length === 0) {
                    if (noProductsMessage) {
                        noProductsMessage.style.display = 'block';
                        const messagePara = noProductsMessage.querySelector('p');
                        if (messagePara) {
                            messagePara.textContent = 'No products in this registry';
                        }
                    }
                    productsList.style.display = 'none';
                }
            }

            /**
             * Initialize controls for OWNER view
             */
            function initializeOwnerControls() {
                // Plus button - increase input value
                document.querySelectorAll('.quantity-btn.plus-btn').forEach(button => {
                    button.addEventListener('click', function() {
                        const productId = this.dataset.productId;
                        const input = document.querySelector(`.quantity-input[data-product-id="${productId}"]`);
                        if (input) {
                            input.value = (parseInt(input.value) || 0) + 1;
                        }
                    });
                });

                // Minus button - decrease input value
                document.querySelectorAll('.quantity-btn.minus-btn').forEach(button => {
                    button.addEventListener('click', function() {
                        const productId = this.dataset.productId;
                        const input = document.querySelector(`.quantity-input[data-product-id="${productId}"]`);
                        if (input) {
                            let value = parseInt(input.value) || 0;
                            if (value > 0) input.value = value - 1;
                        }
                    });
                });

                // Update quantity button - API call
                document.querySelectorAll('.update-quantity-btn').forEach(button => {
                    button.addEventListener('click', async function() {
                        const productId = this.dataset.productId;
                        const input = document.querySelector(`.quantity-input[data-product-id="${productId}"]`);
                        const card = this.closest('.product-card');

                        if (input) {
                            const quantity = parseInt(input.value) || 0;

                            // Show loader, keep text
                            this.disabled = true;
                            const btnText = this.querySelector('.btn-text');
                            const btnLoader = this.querySelector('.btn-loader');
                            if (btnText) btnText.style.display = 'none';
                            if (btnLoader) {
                                btnLoader.style.display = 'inline-block';
                                btnLoader.innerHTML = '<div class="spinner"></div>';
                            }

                            try {
                                await updateProductQuantityInRegistry(productId, quantity);

                                if (quantity === 0 && card) {
                                    // Remove card if quantity is 0
                                    card.remove();
                                    
                                    // Update product count
                                    updateProductCount();

                                    // Check if list is empty
                                    checkEmptyProductsList();
                                } else if (card) {
                                    // Update "Want X • Purchased Y" text
                                    const wantSpan = card.querySelector('.product-want');
                                    if (wantSpan) {
                                        const purchasedMatch = wantSpan.textContent.match(/Purchased (\d+)/);
                                        const purchased = purchasedMatch ? purchasedMatch[1] : '0';
                                        wantSpan.textContent = `Want ${quantity} • Purchased ${purchased}`;
                                    }
                                }

                            } catch (error) {
                                console.error('Error updating quantity:', error);
                                alert('Failed to update quantity');
                            } finally {
                                this.disabled = false;
                                if (btnText) btnText.style.display = '';
                                if (btnLoader) btnLoader.style.display = 'none';
                            }
                        }
                    });
                });
            }

            /**
             * Initialize controls for GIFTER view
             */
            function initializeGifterControls() {
                // Add to cart button - adds full remaining quantity
                document.querySelectorAll('.add-to-cart-btn').forEach(button => {
                    if (!button.disabled) {
                        button.addEventListener('click', function() {
                            const card = this.closest('.product-card');
                            const remainingQty = parseInt(this.dataset.remaining) || 1;

                            let personalizationValue = null;
                                const input = card.querySelector('.personalization-input');
                                const checkbox = card.querySelector('.personalization-checkbox');

                                if (checkbox && checkbox.checked && input && input.value.trim() !== '') {
                                    personalizationValue = input.value.trim();
                                }
                            
                            const product = {
                                id: card.getAttribute('data-product-id'),
                                variant_id: card.getAttribute('data-variant-id'),
                                title: card.getAttribute('data-product-title'),
                                price: card.getAttribute('data-product-price'),
                                image: card.getAttribute('data-product-image'),
                                metafield: card.getAttribute('metafield-data'),
                                quantity: remainingQty,
                                personalization: personalizationValue
                            };

                            addProductToCart(product, this);
                        });
                    }
                });
            }
            
            populateViewRegistry();
            
            /**
             * Filter products by tab - FIXED with proper counting
             */
            window.filterProductsByTab = function(tab) {
                const productCards = document.querySelectorAll('.product-card');
                const noProductsMessage = document.querySelector('.no-products-message');
                const productsList = document.querySelector('.products-list');
                const productsCount = document.querySelector('.products-count');
                let visibleCount = 0;
                
                console.log('Filtering by tab:', tab);
                
                productCards.forEach(card => {
                    const cardTab = card.getAttribute('data-tab') || 'all';
                    
                    let shouldShow = false;
                    
                    if (tab === 'all') {
                        shouldShow = true;
                    } else if (tab === 'still-need' && cardTab === 'still-need') {
                        shouldShow = true;
                    } else if (tab === 'sold-out' && cardTab === 'sold-out') {
                        shouldShow = true;
                    } else if (tab === 'fulfilled' && cardTab === 'fulfilled') {
                        shouldShow = true;
                    }
                    
                    if (shouldShow) {
                        card.style.display = '';
                        visibleCount++;
                    } else {
                        card.style.display = 'none';
                    }
                });
                
                console.log('Visible products:', visibleCount);
                
                // Update product count
                if (productsCount) {
                    productsCount.textContent = `${visibleCount} ${visibleCount === 1 ? 'Product' : 'Products'}`;
                }
                
                // Handle empty state
                if (visibleCount === 0) {
                    if (noProductsMessage) {
                        noProductsMessage.style.display = 'block';
                        const tabName = tab === 'sold-out' ? 'Sold Out' : 
                                       tab === 'fulfilled' ? 'Fulfilled' : 
                                       tab === 'still-need' ? 'Still Need' : 'All';
                        const messagePara = noProductsMessage.querySelector('p');
                        if (messagePara) {
                            messagePara.textContent = `No products in ${tabName}`;
                        }
                    }
                    if (productsList) {
                        productsList.style.display = 'none';
                    }
                } else {
                    if (noProductsMessage) {
                        noProductsMessage.style.display = 'none';
                    }
                    if (productsList) {
                        productsList.style.display = 'flex';
                    }
                }
            };

            // Tab button event listeners
            document.querySelectorAll('.tab-btn').forEach(button => {
                button.addEventListener('click', function() {
                    document.querySelectorAll('.tab-btn').forEach(btn => btn.classList.remove('active'));
                    this.classList.add('active');
                    const tab = this.getAttribute('data-tab');
                    if (window.filterProductsByTab) {
                        window.filterProductsByTab(tab);
                    }
                });
            });

            const editBtn = viewRegistryHeader.querySelector('.edit-btn');
            const shareBtn = viewRegistryHeader.querySelector('.share-btn');
            
            if (editBtn && registryId && isOwnerView) {
                editBtn.addEventListener('click', () => {
                    const regisId = viewRegistryHeader.dataset.registryId;
                    window.location.href = `/pages/update-registry?id=${regisId}`;
                });
            } else if (editBtn && isGifterView) {
                editBtn.style.display = 'none';
            }
            
            if (shareBtn) {
                shareBtn.addEventListener('click', function() {
                    const registryTitle = viewRegistryHeader.querySelector('.registry-title')?.textContent || 'Registry';
                    
                    let shareModal = document.getElementById('viewRegistryShareModal');
                    if (!shareModal) {
                        shareModal = createShareModal();
                    }
                    
                    const modalTitle = shareModal.querySelector('#viewRegistryModalTitle');
                    const shareUrlInput = shareModal.querySelector('#viewRegistryShareUrlInput');
                    
                    if (modalTitle) modalTitle.textContent = `${registryTitle} | ${registryId}`;
                    if (shareUrlInput) {
                        shareUrlInput.value = `${window.location.origin}/pages/view-registry/view-as-gifter?id=${registryId}`;
                    }
                    
                    shareModal.classList.add('active');
                });
            }
            
            function createShareModal() {
                const modal = document.createElement('div');
                modal.id = 'viewRegistryShareModal';
                modal.className = 'share-modal-overlay';
                modal.innerHTML = `
                    <div class="share-modal">
                        <button class="modal-close-btn" id="viewRegistryModalCloseBtn">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <line x1="18" y1="6" x2="6" y2="18"></line>
                                <line x1="6" y1="6" x2="18" y2="18"></line>
                            </svg>
                        </button>
                        <h3 class="modal-title" id="viewRegistryModalTitle"></h3>
                        <div class="modal-content">
                            <p class="modal-message">Share your momentous event!</p>
                            <p class="modal-submessage"><strong>With your family and friends</strong></p>
                            <div class="share-section">
                                <div class="share-label">
                                    <span>Share</span>
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                        <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                                        <polyline points="22,6 12,13 2,6"></polyline>
                                    </svg>
                                </div>
                                <div class="url-input-wrapper">
                                    <input type="text" class="share-url-input" id="viewRegistryShareUrlInput" readonly>
                                    <button class="copy-btn" id="viewRegistryCopyBtn">COPY</button>
                                </div>
                            </div>
                        </div>
                    </div>
                `;
                document.body.appendChild(modal);
                
                const closeBtn = modal.querySelector('#viewRegistryModalCloseBtn');
                const copyBtn = modal.querySelector('#viewRegistryCopyBtn');
                const shareUrlInput = modal.querySelector('#viewRegistryShareUrlInput');
                
                if (closeBtn) {
                    closeBtn.addEventListener('click', () => {
                        modal.classList.remove('active');
                    });
                }
                
                modal.addEventListener('click', (e) => {
                    if (e.target === modal) {
                        modal.classList.remove('active');
                    }
                });
                
                if (copyBtn && shareUrlInput) {
                    copyBtn.addEventListener('click', () => {
                        shareUrlInput.select();
                        
                        navigator.clipboard.writeText(shareUrlInput.value).then(() => {
                            const originalText = copyBtn.textContent;
                            copyBtn.textContent = 'COPIED!';
                            
                            setTimeout(() => {
                                copyBtn.textContent = originalText;
                            }, 2000);
                        }).catch(err => {
                            console.error('Copy failed:', err);
                        });
                    });
                }
                
                return modal;
            }
        }
    }

    // ==========================================
    // UPDATE REGISTRY PAGE
    // ==========================================
    const isUpdateRegistryPage = window.location.pathname.includes('update-registry');
    const updateForm = isUpdateRegistryPage ? document.getElementById("create-registry-form") : 
                                               document.getElementById("update-registry-form");
    const updateHeadingContainer = document.querySelector('.update__registry___container');
    const updateHeadinginner = document.querySelector('.heading-wrapper');
    const updateHeadingcontent = document.querySelector('.regsitry__container');
    
    if (updateForm && isUpdateRegistryPage) {
        console.log('Update Registry Page Loaded');
        
        const updateHeadingWrapper = document.querySelector('.heading-wrapper');
        if (updateHeadingWrapper && updateHeadingWrapper.dataset.customer) {
            customerId = updateHeadingWrapper.dataset.customer;
        }
        
        const urlParams = new URLSearchParams(window.location.search);
        const registryId = urlParams.get('id');
        
        const submitBtn = updateForm.querySelector('.create-registry-btn');
        if (submitBtn) submitBtn.textContent = 'Update Registry';
        
        if (registryId) {
            const populateUpdateForm = async () => {
                const loader = showLoader(updateHeadingContainer);
                
                try {
                    const response = await fetch(`${BASE_URL}/get-registry/${registryId}`);
                    if (!response.ok) throw new Error('Failed to fetch registry');
                    
                    const data = await response.json();
                    
                    if (data.success && data.data) {
                        const registry = data.data;
                        
                        if (!customerId && registry.customer_id) {
                            customerId = registry.customer_id;
                        }
                        
                        if (registry.event_type) document.getElementById("event_type").value = registry.event_type;
                        if (registry.event_date) document.getElementById("event_date").value = registry.event_date;
                        if (registry.registry_name) document.getElementById("registry_name").value = registry.registry_name;
                        if (registry.first_name) document.getElementById("first_name").value = registry.first_name;
                        if (registry.last_name) document.getElementById("last_name").value = registry.last_name;
                        if (registry.share_invitation_message) {
                            document.getElementById("invitation_message").value = registry.share_invitation_message;
                        }
                        
                        if (registry.registrant_address_info) {
                            const address = registry.registrant_address_info;
                            if (address.address1) document.getElementById("start_address").value = address.address1;
                            if (address.city) document.getElementById("city").value = address.city;
                            if (address.state) document.getElementById("state").value = address.state;
                            if (address.zip) document.getElementById("zip_code").value = address.zip;
                            if (address.country) document.getElementById("country").value = address.country;
                            if (address.phone) document.getElementById("phone_number").value = address.phone;
                        }
                    }
                } catch (error) {
                    console.error('Update Form Populate Error:', error);
                } finally {
                    hideLoader(loader);
                    if (updateHeadinginner || updateHeadingcontent) {
                        updateHeadinginner.style.display = '';
                        updateHeadingcontent.style.display = '';
                    }
                }
            };
            
            populateUpdateForm();
            
            updateForm.addEventListener("submit", async (e) => {
                e.preventDefault();
        
                const registryData = {
                    customer_id: customerId,
                    // event_type: document.getElementById("event_type").value,
                    // event_date: document.getElementById("event_date").value,
                    registry_name: document.getElementById("registry_name").value,
                    first_name: document.getElementById("first_name").value,
                    last_name: document.getElementById("last_name").value,
                    share_invitation_message: document.getElementById("invitation_message").value,
                    registrant_address_info: {
                        address1: document.getElementById("start_address").value,
                        zip: document.getElementById("zip_code").value,
                        city: document.getElementById("city").value,
                        state: document.getElementById("state").value,
                        country: document.getElementById("country").value,
                        phone: document.getElementById("phone_number").value
                    }
                };
                
                const submitButton = updateForm.querySelector('button[type="submit"]');
                const originalText = submitButton ? submitButton.textContent : '';
                let btnLoader;
                if (submitButton) {
                    submitButton.disabled = true;
                    submitButton.textContent = ' ';
                    btnLoader = showLoader(submitButton);
                    if (btnLoader) {
                        btnLoader.classList.add('button-loader');
                    }
                }
        
                try {
                    const response = await fetch(`${BASE_URL}/update-registry/${registryId}`, {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify(registryData)
                    });
        
                    const data = await response.json();
        
                    if (data.success) {
                        window.location.href = "manage-registry";
                    } else {
                        alert("Error: " + data.message);
                    }
                } catch (error) {
                    console.error("Update Registry Error:", error);
                    alert("Request failed. Please try again.");
                } finally {
                    if (submitButton) {
                        submitButton.disabled = false;
                        submitButton.textContent = originalText;
                        hideLoader(btnLoader);
                    }
                }
            });
        }
    }


    // const searchForm = document.getElementById("search-registry-form");
    // const searchResultsSection = document.querySelector(".search-results-section");
    // const searchRegistryWrapper = document.querySelector(".search-registry-cards-wrapper");
    
    // const searchModalOverlay = document.getElementById('shareModalOverlay');
    // const searchModalCloseBtn = document.getElementById('modalCloseBtn');
    // const searchModalTitle = document.getElementById('modalTitle');
    // const searchShareUrlInput = document.getElementById('shareUrlInput');
    // const searchCopyBtn = document.getElementById('copyBtn');
    
    // if (searchForm && searchRegistryWrapper) {
    //     console.log('Search Registry Page Loaded');
        
    //     const populateSearchResults = (registries) => {
    //         const templateCard = searchRegistryWrapper.querySelector('.registry-card');
    //         const emptyState = searchRegistryWrapper.querySelector('.empty-registry-state');
            
    //         if (!templateCard || !emptyState) return;

    //         if (!registries || registries.length === 0) {
    //             searchRegistryWrapper.querySelectorAll('.registry-card').forEach(card => card.style.display = 'none');
    //             emptyState.style.display = 'block';
    //         } else {
    //             searchResultsSection.style.display = 'block';
    //             emptyState.style.display = 'none';
    //             templateCard.style.display = 'none';
                
    //             searchRegistryWrapper.querySelectorAll('.registry-card:not([data-template])').forEach(card => card.remove());
    //             templateCard.setAttribute('data-template', 'true');
                
    //             registries.forEach(registry => {
    //                 const card = templateCard.cloneNode(true);
    //                 card.removeAttribute('data-template');
    //                 card.style.display = '';

    //                 card.querySelector('.avatar-initials').textContent = 
    //                     (registry.first_name?.charAt(0) || '') + (registry.last_name?.charAt(0) || '');
    //                 card.querySelector('.registry-name').textContent = registry.registry_name || '';
    //                 card.querySelector('.detail-item:nth-child(1) .detail-value').textContent = registry.id || '';
    //                 card.querySelector('.detail-item:nth-child(2) .detail-value').textContent = registry.event_date || '';
    //                 card.querySelector('.detail-item:nth-child(3) .detail-value').textContent = registry.event_type || '';
    //                 card.querySelector('.invitation-quote p').textContent = registry.share_invitation_message || '';
                    
    //                 const viewBtn = card.querySelector('.view-registry-btn');
    //                 if (viewBtn) viewBtn.setAttribute('data-registry-id', registry.registry_id || registry.id || '');

    //                 const shareBtn = card.querySelector('.share-icon');
    //                 if (shareBtn) {
    //                     shareBtn.dataset.registryName = registry.registry_name || '';
    //                     shareBtn.dataset.registryId = registry.id || '';
    //                 }

    //                 const editBtn = card.querySelector('.edit-icon');
    //                 if (editBtn) editBtn.dataset.registryId = registry.id || '';

    //                 const deleteBtn = card.querySelector('.delete-icon');
    //                 if (deleteBtn) deleteBtn.dataset.registryId = registry.id || '';

    //                 searchRegistryWrapper.appendChild(card);
    //             });
    //         }
    //     };

    //     searchForm.addEventListener("submit", async (e) => {
    //         e.preventDefault();
            
    //         const query = document.getElementById("registry_search").value.trim();
            
    //         if (!query) {
    //             alert("Please enter a search query");
    //             return;
    //         }
            
    //         const searchBtn = searchForm.querySelector('button[type="submit"]');
    //         const originalBtnText = searchBtn ? searchBtn.textContent : '';
    //         let btnLoader = null;
            
    //         if (searchBtn) {
    //             searchBtn.disabled = true;
    //             searchBtn.textContent = ' ';
    //             btnLoader = showLoader(searchBtn);
    //             btnLoader.classList.add('button-loader');
    //         }

    //         const loader = showLoader(searchRegistryWrapper);

    //         try {
    //             const response = await fetch(`${BASE_URL}/search-registries?query=${encodeURIComponent(query)}`);
    //             const data = await response.json();

    //             if (data.success) {
    //                 populateSearchResults(data.data || []);
    //             } else {
    //                 console.error("Search Error:", data.message);
    //                 populateSearchResults([]);
    //             }
    //         } catch (error) {
    //             console.error("Search Request Error:", error);
    //             populateSearchResults([]);
    //         } finally {
    //             hideLoader(loader);
    //             hideLoader(btnLoader);
    //             if (searchBtn) {
    //                 searchBtn.textContent = originalBtnText;
    //                 searchBtn.disabled = false;
    //             }
    //         }
    //     });

    //     searchRegistryWrapper.addEventListener('click', (e) => {
    //         const editBtn = e.target.closest('.edit-icon');
    //         if (editBtn && editBtn.dataset.registryId) {
    //             window.location.href = `update-registry?id=${editBtn.dataset.registryId}`;
    //         }
    //     });

    //     searchRegistryWrapper.addEventListener('click', async (e) => {
    //         const deleteBtn = e.target.closest('.delete-icon');
    //         if (!deleteBtn || !deleteBtn.dataset.registryId) return;
            
    //         if (!confirm('Are you sure you want to delete this registry?')) {
    //             return;
    //         }

    //         const registryId = deleteBtn.dataset.registryId;

    //         try {
    //             const response = await fetch(`${BASE_URL}/delete-registry/${registryId}`, {
    //                 method: "POST",
    //                 headers: { "Content-Type": "application/json" }
    //             });

    //             const data = await response.json();

    //             if (data.success) {
    //                 const query = document.getElementById("registry_search").value.trim();
    //                 if (query) {
    //                     const searchResponse = await fetch(`${BASE_URL}/search-registries?query=${encodeURIComponent(query)}`);
    //                     const searchData = await searchResponse.json();
    //                     populateSearchResults(searchData.success ? searchData.data || [] : []);
    //                 } else {
    //                     populateSearchResults([]);
    //                 }
    //             } else {
    //                 alert("Error: " + (data.message || "Unknown error"));
    //             }
    //         } catch (error) {
    //             console.error("Delete Error:", error);
    //             alert("Delete failed. Please try again.");
    //         }
    //     });

    //     searchRegistryWrapper.addEventListener('click', function(e) {
    //         const shareButton = e.target.closest('.share-icon');
    //         if (shareButton) {
    //             const registryName = shareButton.getAttribute('data-registry-name');
    //             const registryId = shareButton.getAttribute('data-registry-id');
                
    //             if (searchModalTitle) {
    //                 searchModalTitle.textContent = `${registryName} | ${registryId}`;
    //             }
                
    //             if (searchShareUrlInput) {
    //                 const baseUrl = window.location.origin;
    //                 searchShareUrlInput.value = `${baseUrl}/pages/view-registry/view-as-gifter?id=${registryId}`;
    //             }
                
    //             if (searchModalOverlay) {
    //                 searchModalOverlay.classList.add('active');
    //             }
    //         }
    //     });
    // }

    // if (searchModalCloseBtn) {
    //     searchModalCloseBtn.addEventListener('click', function() {
    //         if (searchModalOverlay) {
    //             searchModalOverlay.classList.remove('active');
    //         }
    //     });
    // }
    
    // if (searchModalOverlay) {
    //     searchModalOverlay.addEventListener('click', function(e) {
    //         if (e.target === searchModalOverlay) {
    //             searchModalOverlay.classList.remove('active');
    //         }
    //     });
    // }
    
    // if (searchCopyBtn && searchShareUrlInput) {
    //     searchCopyBtn.addEventListener('click', function() {
    //         searchShareUrlInput.select();
    //         searchShareUrlInput.setSelectionRange(0, 99999);
            
    //         navigator.clipboard.writeText(searchShareUrlInput.value).then(function() {
    //             const originalText = searchCopyBtn.textContent;
    //             searchCopyBtn.textContent = 'COPIED!';
                
    //             setTimeout(function() {
    //                 searchCopyBtn.textContent = originalText;
    //             }, 2000);
    //         }).catch(function() {
    //             try {
    //                 document.execCommand('copy');
    //                 const originalText = searchCopyBtn.textContent;
    //                 searchCopyBtn.textContent = 'COPIED!';
                    
    //                 setTimeout(function() {
    //                     searchCopyBtn.textContent = originalText;
    //                 }, 2000);
    //             } catch (err) {
    //                 console.error('Copy failed');
    //             }
    //         });
    //     });
    // }

    // ==========================================
    // ADD PRODUCT TO REGISTRY
    // ==========================================
    const registryButton = document.getElementById('registryButton');
    const selectRegistryModal = document.getElementById('selectRegistryModal');
    const closeRegistryModal = document.getElementById('closeRegistryModal');
    const registryList = document.getElementById('registryList');
    const updateRegistryBtn = document.getElementById('updateRegistryBtn');
    const metafieldEl = document.querySelector('.product_metafield_data');
    const customizationValue = metafieldEl ? metafieldEl.textContent.trim() : '';
        const metafieldJson = {
        customization_1: customizationValue
    };
    
    if (registryButton && selectRegistryModal) {
        let selectedRegistry = null;
        let registries = [];
        let btnCustomerId = window.registryCustomerId || customerId;
        
        async function fetchRegistries() {
            registryList.innerHTML = '';
            const loader = showLoader(registryList);
            
            try {
                const response = await fetch(`${BASE_URL}/list-registries?customer_id=${btnCustomerId}`);
                const data = await response.json();
                
                hideLoader(loader);
                
                if (data.success && data.data && data.data.length > 0) {
                    registries = data.data;
                    populateRegistryList(registries);
                } else {
                    registryList.innerHTML = '<div style="padding: 20px; text-align: center; color: #666;">No registries found. Please create a registry first.</div>';
                }
            } catch (error) {
                console.error('Fetch Registries Error:', error);
                hideLoader(loader);
                registryList.innerHTML = '<div style="padding: 20px; text-align: center; color: #d32f2f;">Error loading registries</div>';
            }
        }
        
        function populateRegistryList(registriesList) {
            registryList.innerHTML = '';
            
            if (registriesList.length === 0) {
                registryList.innerHTML = '<div style="padding: 20px; text-align: center; color: #666;">No registries found</div>';
                return;
            }

            registriesList.forEach((registry, index) => {
                const item = document.createElement('label');
                item.className = 'select-registry-item';
                
                const registryId = registry.id || registry.registry_id;
                const registryName = registry.registry_name || 'Unnamed Registry';

                item.innerHTML = `
                    <input 
                        type="radio" 
                        name="selectedRegistry" 
                        value="${registryId}"
                        ${index === 0 ? 'checked' : ''}
                    />
                    <span>${registryName}</span>
                `;

                if (index === 0) {
                    item.classList.add('selected');
                    selectedRegistry = item;
                }

                item.setAttribute('data-registry-id', registryId);
                item.setAttribute('data-registry-name', registryName);

                item.addEventListener('click', function () {
                    registryList.querySelectorAll('.select-registry-item').forEach(regItem => {
                        regItem.classList.remove('selected');
                        regItem.querySelector('input').checked = false;
                    });

                    this.classList.add('selected');
                    this.querySelector('input').checked = true;
                    selectedRegistry = this;
                });

                registryList.appendChild(item);
            });
        }
        
        registryButton.addEventListener('click', (e) => {
            e.preventDefault();
            
            if (!btnCustomerId) {
                window.location.href = '/account/login';
                return;
            }
            
            fetchRegistries();
            selectRegistryModal.classList.add('active');
        });
        
        if (closeRegistryModal) {
            closeRegistryModal.addEventListener('click', () => {
                selectRegistryModal.classList.remove('active');
                selectedRegistry = null;
            });
        }
        
        selectRegistryModal.addEventListener('click', (e) => {
            if (e.target === selectRegistryModal) {
                selectRegistryModal.classList.remove('active');
                selectedRegistry = null;
            }
        });
        
        if (updateRegistryBtn) {
            updateRegistryBtn.addEventListener('click', async () => {
                if (!selectedRegistry) {
                    alert('Please select a registry');
                    return;
                }
            
                const productData = window.productData;
                if (!productData || !productData.id) {
                    alert('Product information not available');
                    return;
                }
                console.log(productData);
                
                const registryId = selectedRegistry.getAttribute('data-registry-id');
                
                const productPayload = {
                    id: productData.id,
                    title: productData.title,
                    image: productData.image || '',
                    price: productData.price || '0.00',
                    quantity: 1,
                    variant_id: productData.variantid,
                    metafields: JSON.stringify(metafieldJson),
                    original_quantity: productData.quantity
                };
                
                updateRegistryBtn.disabled = true;
                updateRegistryBtn.textContent = '';
                const loader = showLoader(updateRegistryBtn);
                loader.classList.add('button-loader');
                
                try {
                    const response = await fetch(`${BASE_URL}/add-products-to-registry`, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({
                            id: parseInt(registryId),
                            products: [productPayload]
                        })
                    });
                    
                    const data = await response.json();
                    
                    if (data.success) {
                        selectRegistryModal.classList.remove('active');
                        selectedRegistry = null;
                        console.log(data);
                    } else {
                        alert('Error: ' + (data.message || 'Unknown error'));
                    }
                } catch (error) {
                    console.error('Add Product Error:', error);
                    alert("Failed to add product");
                } finally {
                    updateRegistryBtn.disabled = false;
                    updateRegistryBtn.textContent = 'Update Registry';
                    hideLoader(loader);
                }
            });
        }
    }

    // ==========================================
    // CART FUNCTIONS
    // ==========================================
    
    /**
     * Add product to cart and open cart drawer
     */
    function addProductToCart(product, buttonElement) {
        console.log('Adding product to cart:', product);
        
        let cart = getLocalCart();
        
        // Check if product already exists
        // const existingItemIndex = cart.findIndex(item => item.variant_id === product.variant_id);
        const existingItemIndex = cart.findIndex(item => 
    item.variant_id === product.variant_id &&
    (item.value || '') === (product.personalization || '')
);

        
        if (existingItemIndex !== -1) {
            // Increase quantity
            cart[existingItemIndex].quantity = parseInt(cart[existingItemIndex].quantity) + parseInt(product.quantity);

                    if (product.personalization) {
            cart[existingItemIndex].value = product.personalization;
        }
        } else {
            // Add new product
            cart.push({
                product_id: product.id,
                variant_id: product.variant_id,
                title: product.title,
                image: product.image || '',
                price: product.price || '0.00',
                quantity: parseInt(product.quantity),
                value: product.personalization
            });
        }
        
        saveLocalCart(cart);
        
        if (buttonElement) {
            const btnText = buttonElement.querySelector('.btn-text');
            const btnLoader = buttonElement.querySelector('.btn-loader');
            
            // Show loader briefly
            if (btnText && btnLoader) {
                btnText.style.display = 'none';
                btnLoader.style.display = 'inline-block';
                btnLoader.innerHTML = '<div class="spinner"></div>';
                
                setTimeout(() => {
                    btnText.textContent = 'Added!';
                    btnText.style.display = '';
                    btnLoader.style.display = 'none';
                    buttonElement.classList.add('added');
                    
                    setTimeout(() => {
                        btnText.textContent = 'Add to Cart';
                        buttonElement.classList.remove('added');
                    }, 1500);
                }, 300);
            } else {
                // Fallback for buttons without loader structure
                const originalText = buttonElement.textContent;
                buttonElement.textContent = 'Added!';
                buttonElement.classList.add('added');
                
                setTimeout(() => {
                    buttonElement.textContent = originalText;
                    buttonElement.classList.remove('added');
                }, 2000);
            }
        }
        
        // Open cart drawer
        setTimeout(() => {
            openCartDrawer();
        }, 500);
    }




        const countriesUrl = 'https://countriesnow.space/api/v0.1/countries/positions';
const statesUrl = 'https://countriesnow.space/api/v0.1/countries/states';

const countrySelect = document.getElementById('country');
const stateSelect = document.getElementById('state');
async function loadCountries() {
  try {
    const response = await fetch('https://countriesnow.space/api/v0.1/countries/states');
    const data = await response.json();
    data.data.forEach(country => {
      const option = document.createElement('option');
      option.value = country.name;
      option.textContent = country.name;
      countrySelect.appendChild(option);
    });
  } catch (err) {
    console.error('Error loading countries:', err);
  }
}

// 2️⃣ Load states when country changes
countrySelect.addEventListener('change', async function() {
  const countryName = this.value;
  stateSelect.innerHTML = '<option value="">Select State</option>'; // reset

  if (!countryName) return;

  try {
    const response = await fetch(statesUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ country: countryName })
    });
    const result = await response.json();

    if (result.data && result.data.states.length > 0) {
      result.data.states.forEach(state => {
        const option = document.createElement('option');
        option.value = state.name;
        option.textContent = state.name;
        stateSelect.appendChild(option);
      });
    } else {
      const option = document.createElement('option');
      option.value = '';
      option.textContent = 'No states available';
      stateSelect.appendChild(option);
    }
  } catch (err) {
    console.error('Error loading states:', err);
  }
});

// Initialize

    loadCountries();



    // Make functions globally accessible
    window.addProductToCart = addProductToCart;
    window.openCartDrawer = openCartDrawer;
    window.closeCartDrawer = closeCartDrawer;
    window.getLocalCart = getLocalCart;


});

document.addEventListener('change', function (e) {
    if (!e.target.classList.contains('personalization-checkbox')) return;

    const productId = e.target.dataset.productId;

    const container = document.querySelector(
        `.personalization-container[data-product-id="${productId}"]`
    );
    if (!container) return;

    const input = container.querySelector('.personalization-input');
    const labelSpan = container.querySelector('.product_card-label');
    const custumizeTExt = container.querySelector('#product_max');
    const CustumisPrice = container.querySelector('#productPrice_cost');

    if (!input) return;

    if (e.target.checked) {
        input.style.display = 'block';
        if (labelSpan) labelSpan.style.display = 'block';
        if (custumizeTExt) custumizeTExt.style.display = 'block';
        if (CustumisPrice) CustumisPrice.style.display = 'block';
    } else {
        input.style.display = 'none';
        input.value = '';
        if (labelSpan) labelSpan.style.display = 'none';
        if (custumizeTExt) custumizeTExt.style.display = 'none';
        if (CustumisPrice) CustumisPrice.style.display = 'none';
    }
});